import React from 'react';

import styled from '@emotion/styled';

import { getColorTint, unit } from '@zego/theme';

import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';

const BannerContainer = styled.div({
  position: 'relative',
  paddingTop: unit(3),
  paddingBottom: unit(3),
  zIndex: 9999,
});

interface BannerProps {
  backgroundColor?: string;
  testId: string;
  children: React.ReactNode;
}

export default function Banner({
  backgroundColor = getColorTint('green', 7),
  testId,
  children,
}: BannerProps): JSX.Element {
  return (
    <BannerContainer
      data-testid={testId}
      css={{
        backgroundColor: backgroundColor,
      }}
    >
      <ContentContainer>
        <View
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </View>
      </ContentContainer>
    </BannerContainer>
  );
}
